import { defineMessages } from "react-intl";

import {
	timmSignedMessages,
	validator
} from "lib/build/forms/ltx/patientStatementOfConsentTimm";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientStatementOfConsentTimm: {
		id: "ktx.form.patient_statement_of_consent_timm",
		defaultMessage: "Páciens beleegyező nyilatkozat (TIMM)"
	},
	timmSigned: {
		id: "ktx.form.patient_statement_of_consent_timm.signed",
		defaultMessage:
			"Kérjük az űrlaphoz töltse fel mellékletként az aláírt nyilatkozatot beszkennelt vagy lefotózott formában és a nyilatkozatot papír alapon őrizze meg a beküldő intézmény."
	}
});

const fields: { [key: string]: FieldData } = {
	timmSigned: {
		type: "field",
		path: ["timmSigned"],
		label: messages.timmSigned,
		errorMessages: genericErrorMessages,
		input: { type: "radio-group", props: { labels: timmSignedMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.timmSigned }] }]
};

export const node: LeafNode = {
	id: "ktx_patientStatementOfConsentTimm",
	value: {
		schemaId: "patientStatementOfConsentTimm",
		title: messages.patientStatementOfConsentTimm,
		validator,
		fieldset
	}
};
